export const ROLES = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  AGENT: 'AGENT',
  VERIFIER: 'VERIFIER',
  READONLY: 'READONLY',
  APPLICANT: 'APPLICANT',
  COMPLIANCE_ADMIN: 'COMPLIANCE_ADMIN'
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  PROPERTIES: '/properties',
  PROPERTY_DETAIL: '/properties/:id',
  AUDIT: '/audit',
  APPLICATIONS: '/applications',
  APPLICATION_DETAIL: '/applications/:id',
  APPLY_INVITE: '/apply/:token',
  APPLICANT_PORTAL: '/applicant',
  APPLICANT_APPLICATION: '/applicant/application/:id',
  APPLY_PROPERTY: '/apply-to/:token',
  MY_DATA: '/my-data',
  PROPERTY_APPLICANTS: '/property-applicants',
  GET_STARTED: '/get-started',
  ORGANISATION: '/organisation',
  ORGANISATION_INVITATIONS: '/organisation-invitations',
  ADMIN_MANDATES: '/admin/mandates',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  CONSENT_PAGE: '/applicant/consent/:applicationId',
  VERIFICATION: '/verification',
  VERIFICATION_TASK: '/verification/:taskId',
  REFERENCE_RESPONSE: '/references/:token',
  REPORT: '/applications/:id/report',
  DECISION: '/applications/:id/decision',
  // Disputes are always about one application (the API has no cross-application listing) — an
  // applicant raises one from their own application page (ApplicantApplicationPage), and staff
  // review/act on them here.
  DISPUTES: '/applications/:id/disputes',
  BILLING: '/billing',
  ADMIN: '/admin',
  PASSPORT: '/passport',
  ACCOUNT: '/account',
  LISTINGS: '/listings',
  MY_LEASES: '/my-lease'
};

export const DECISION_OUTCOMES = {
  SHORTLIST: 'SHORTLIST',
  APPROVE: 'APPROVE',
  DECLINE: 'DECLINE',
  REQUEST_INFO: 'REQUEST_INFO'
};

export const REASON_CODES = {
  INSUFFICIENT_INCOME: 'Insufficient verified income',
  INCOMPLETE_DOCS: 'Incomplete documentation',
  REFERENCE_ISSUE: 'Unresolved reference issue',
  CREDIT_ADVERSE: 'Adverse credit history',
  AFFORDABILITY_FAIL: 'Failed affordability criteria'
};

export const DISPUTE_STATUSES = {
  SUBMITTED: 'SUBMITTED',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  INVESTIGATING: 'INVESTIGATING',
  CORRECTED: 'CORRECTED',
  UPHELD: 'UPHELD',
  ESCALATED: 'ESCALATED'
};

export const DISPUTE_TYPES = {
  FACTUAL_ERROR: 'Factual error',
  INCOMPLETE_DATA: 'Incomplete data',
  INCORRECT_SOURCE: 'Incorrect source',
  OTHER: 'Other'
};

export const DELETION_STATUSES = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED'
};

export const BILLING_TYPES = {
  SINGLE_REPORT: 'SINGLE_REPORT',
  SUBSCRIPTION: 'SUBSCRIPTION',
  REFUND: 'REFUND'
};

export const BILLING_STATUSES = {
  AUTHORIZED: 'AUTHORIZED',
  CHARGED: 'CHARGED',
  REFUNDED: 'REFUNDED'
};

export const TEMPLATE_TYPES = {
  NOTICE: 'NOTICE',
  CONSENT: 'CONSENT',
  QUESTIONNAIRE: 'QUESTIONNAIRE',
  REASON_CODES: 'REASON_CODES',
  RETENTION: 'RETENTION'
};

export const QUEUE_TYPES = {
  VERIFICATION: 'VERIFICATION',
  DISPUTES: 'DISPUTES',
  DELETIONS: 'DELETIONS',
  INCIDENTS: 'INCIDENTS',
  SUPPORT: 'SUPPORT'
};

export const QUEUE_PRIORITIES = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL'
};

export const PASSPORT_STATUSES = {
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  REVOKED: 'REVOKED'
};


// Values mirror the backend enums in database/migrations.
export const APPLICATION_STATUSES = {
  DRAFT: 'draft',
  INVITED: 'invited',
  CONSENT_PENDING: 'consent_pending', // UI-only step; the API moves invited -> started
  IN_PROGRESS: 'started',
  SUBMITTED: 'submitted',
  VERIFICATION_IN_PROGRESS: 'verification_in_progress',
  MORE_INFO_REQUIRED: 'more_info_required',
  REPORT_READY: 'report_ready',
  DECISION_RECORDED: 'decision_recorded',
  DISPUTED: 'disputed',
  COMPLETED: 'closed',
  DELETION_PENDING: 'deletion_pending',
  DELETED: 'deleted'
};

export const CHECK_TYPES = {
  IDENTITY: 'identity',
  INCOME: 'income',
  AFFORDABILITY: 'affordability',
  CREDIT: 'credit',
  EMPLOYMENT_REFERENCE: 'employment_reference',
  LANDLORD_REFERENCE: 'landlord_reference'
};

export const VERIFICATION_STATUSES = {
  NOT_REQUESTED: 'not_requested',
  CONSENT_REQUIRED: 'consent_required',
  PENDING: 'pending',
  VERIFIED: 'verified',
  ATTENTION_REQUIRED: 'attention_required',
  INCONCLUSIVE: 'inconclusive',
  UNAVAILABLE: 'unavailable',
  EXPIRED: 'expired',
  DISPUTED: 'disputed',
  CORRECTED: 'corrected'
};

export const DOCUMENT_TYPES = {
  id_document: 'ID document',
  proof_of_income: 'Proof of income',
  bank_statement: 'Bank statement',
  employment_letter: 'Employment letter',
  proof_of_address: 'Proof of address',
  other: 'Other'
};

export const CONSENT_CHECK_TYPES = {
  identity: {
    label: 'Identity verification',
    description: 'Confirm your identity against the ID document you provide.',
    mandatory: true
  },
  income: {
    label: 'Income verification',
    description: 'Verify your income from payslips and bank statements.',
    mandatory: true
  },
  credit: {
    label: 'Credit check',
    description: 'Obtain a credit report from an authorised bureau.',
    mandatory: false
  },
  employment_reference: {
    label: 'Employer reference',
    description: 'Contact your employer to confirm employment details.',
    mandatory: false
  },
  landlord_reference: {
    label: 'Previous landlord reference',
    description: 'Contact a previous landlord about your tenancy.',
    mandatory: false
  }
};
